import LogoTrade from '../src/LogoTrade';
export default LogoTrade;
